export var Top = 'top';
export var Left = 'left';
export var Right = 'right';
export var Bottom = 'bottom';



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-view-transforms/src/orient.js
// module id = null
// module chunks = 